import React from "react";
import PropTypes from "prop-types";
import { getPropsFromData, CheckboxField, InputField } from "../../FormField";

const DataProtection = ({ data }) => {
  return (
    <table>
      <thead>
        <tr className="table-title">
          <th>G) PERSONAL DATA PROTECTION NOTIFICATION</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <p>I/ We acknowledge that:</p>
            <div style={{ paddingLeft: 15 }}>
              <p>
                1) To process, administer and/or manage My/Our relationship, account and policy with
                Raffles Health Insurance Pte. Ltd., You will necessarily need to collect, use,
                disclose and/or process My/Our personal data or personal information about Me/Us.
                Such personal data includes:
              </p>
              <p>
                (i) information set out in this proposal/ application form and any other personal
                information provided by Me/Us or possessed by Raffles Health Insurance Pte. Ltd. and
                (ii) my/our claims.
              </p>
              <p>
                2) Such personal data will be collected, used, disclosed and/or processed by Raffles
                Health Insurance Pte. Ltd. for the purpose(s) of :
              </p>
              <p>(a) considering whether to provide Me/Us with the insurance I/We applied for;</p>
              <p>(b) processing My/Our application for underwriting and insurance;</p>
              <p>
                (c) Administering and/or managing My/Our relationship, account and/or policy with
                Raffles Health Insurance Pte. Ltd.;
              </p>
              <p>
                (d) processing and/or dealing with any claims including the settlement of claims and
                any necessary investigations relating to the claims, under My/Our policy;
              </p>
              <p>
                (e) Carrying out due diligence or other screening activities (including background
                checks) in accordance with legal or regulatory obligations or risk management
                procedures that may be required by law or that may have been put in place by Raffles
                Health Insurance Pte. Ltd.;
              </p>
              <p>(f) Carrying out My/Our instructions or responding to any enquiries by Me/Us;</p>
              <p>
                (g) Dealing in any matters relating to the services and/or products which I/We are
                entitled to under this policy which I/We are applying for or have applied;
                (including the mailing of correspondence, statements, invoices, reports or notices
                to Me/Us, which could involve disclosure of certain personal data about Me/Us to
                bring about delivery of the same as well as on the external cover of envelopes/mail
                packages);
              </p>
              <p>
                (h) Investigating fraud, misconduct, any unlawful action or omission, whether
                relating to My/Our application, My/Our claims or any other matter relating to My/Our
                policy, and whether or not there is any suspicion of the aforementioned; and/or
              </p>
              <p>
                (i) Complying with applicable law in administering and managing My/Our relationship
                with Raffles Health Insurance Pte. Ltd.
              </p>
              <p>
                (j) sending me marketing, advertising and promotional information about other
                insurance, investment and/or financial products and/or services that Raffles Health
                Insurance Pte. Ltd. may be selling or marketing, and which Raffles Health Insurance
                Pte. Ltd. believes may be of interest or benefit to me, by the following modes of
                communication:
              </p>
              <ul>
                <li>
                  <p>
                    postal mail, electronic transmission to my email address, SMS/MMS (text message)
                    and fax;
                  </p>
                  <p>
                    <CheckboxField {...getPropsFromData(data, "UnsubscribeCommunication")} /> Please
                    tick this box if you do not wish to receive communication via postal mail,
                    email, SMS/MMS (text message) and fax.
                  </p>
                </li>
                <li>
                  <p>
                    to my telephone number(s):
                    <InputField fullDisplay={true} {...getPropsFromData(data, "TelephoneNo1")} />;
                    <InputField fullDisplay={true} {...getPropsFromData(data, "TelephoneNo2")} />;
                    <InputField fullDisplay={true} {...getPropsFromData(data, "TelephoneNo3")} /> by
                    way of :
                  </p>
                  <p>
                    <CheckboxField {...getPropsFromData(data, "UnsubscribeVoiceCall")} /> voice call
                    (Please tick this box if you do not wish to receive communication via voice
                    calls)
                  </p>
                </li>
              </ul>
              <p>(Collectively the “Purposes”)</p>
              <p>
                3) Raffles Health Insurance Pte. Ltd. may/will also be collecting from sources other
                than Myself/Ourselves, personal data about Me/Us, for one or more of the above
                Purposes, and thereafter using, disclosing and/or processing such personal data for
                one or more of the above Purposes.
              </p>
              <p>
                4) My/Our personal data may/will be disclosed by Raffles Health Insurance Pte. Ltd.
                to its reinsurers, third party service providers or agents (including its lawyers /
                law firms), which may be sited outside of Singapore, for one or more of the above
                Purposes, as such third party service providers or agents, if engaged by Raffles
                Health Insurance Pte. Ltd, would be processing My/Our personal data for Raffles
                Health Insurance Pte. Ltd. for one or more of the above Purposes.
              </p>
              <p>
                5) By signing on this proposal or application form, I/We consent to Raffles Health
                Insurance Pte. Ltd in:
              </p>
              <p>
                (a) collecting, using, disclosing and/or processing My/Our personal data for the
                Purposes as described above;
              </p>
              <p>
                (b) collecting personal data about Me/Us from sources other than Myself/Ourselves
                and using, disclosing and/or processing the same, for one or more of the Purposes as
                described above;
              </p>
              <p>
                (c) disclosing My/Our personal data to its third party service providers, or agents
                (including its lawyers / law firms), for the Purposes as described above; and
              </p>
              <p>
                (d) transferring My/Our personal data out of Singapore to its third party service
                providers, or agents where such third party service providers or agents are sited
                (whether in Singapore or outside of Singapore), for the Purposes as described above.
              </p>
              <p>
                (e) representing and warrant that My/Our personal data provided in this form, for
                the purpose as described above and have read and understood the above provisions.
              </p>
              <p style={{ color: "red", marginTop: 60 }}>
                <b>Important Note</b>: Individuals aged 16 and above are required to provide consent
                for the collection, use, and disclosure of their personal information.
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

DataProtection.propTypes = {
  data: PropTypes.object,
};

export default DataProtection;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/DataProtection.jsx